import React from 'react';
import { View } from 'react-native';

interface HeaderProps {
  LeftLogo: React.ReactNode;
  RightFlag: React.ReactNode;
}

const Header = ({ LeftLogo, RightFlag }: HeaderProps) => {
  return (
    <>
      <View className="flex-row justify-between align-center mt-8">
        <View className="my-auto">{LeftLogo}</View>
        {RightFlag}
      </View>

      <View className="w-full h-[1px] bg-gray-200 mb-8" />
    </>
  );
};

export default Header;
